// import adminReducer from "@/components/donations/admin/ducks/reducer"

import adminReducer from "@/components/donations/admin/ducks/slice"
import userReducer from "@/components/donations/ducks/reducer"
import volunteerReducer from "@/components/donations/volunteer/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const donationsReducer = combineReducers({
  admin: adminReducer,
  user: userReducer,
  volunteer: volunteerReducer,
})

export default donationsReducer
